export const environment = {
    production: false,
    company: 'FRÍAS NUTRICIÓN, S.A.U.',
    apiURL: 'https://frias.canaldelinformante.com/backend',
    address: 'C/ Montes de Oca 24 – Pol. Ind. Villalonquéjar, 09001 Burgos'
};
